import { defineMessages } from 'react-intl';
export default defineMessages({
  actionmakeoutBillUnsupport: {
    id: 'action.makeoutBillUnsupport',
    defaultMessage: '该门店不支持开票',
  },
  actionnomoreOrderInfo: {
    id: 'action.nomoreOrderInfo',
    defaultMessage: '没有更多的历史订单数据了',
  },
  actiongetOrderListFailed: {
    id: 'action.getOrderListFailed',
    defaultMessage: '订单列表获取失败',
  },
  actiongetPayInfoFailed: {
    id: 'action.getPayInfoFailed',
    defaultMessage: '获取支付信息失败',
  },
  actionpaySuccess: {
    id: 'action.paySuccess',
    defaultMessage: '您已经支付成功了',
  },
  actionconnectWithWaiter: {
    id: 'action.connectWithWaiter',
    defaultMessage: '请联系服务员线下支付',
  },
  actiongetOrderFailed: {
    id: 'action.getOrderFailed',
    defaultMessage: '获取订单失败, 即将刷新页面...',
  },
  acitongetPagePayParamFailed: {
    id: 'aciton.getPagePayParamFailed',
    defaultMessage: '获取网页支付参数失败，请稍后重试',
  },
  actionShopParamRefresh: {
    id: 'action.ShopParamRefresh',
    defaultMessage: '商户参数更新，请重新点击支付',
  },
  actiongetPagePayUrlFailed: {
    id: 'action.getPagePayUrlFailed',
    defaultMessage: '获取网页支付链接失败，请稍后重试',
  },
  actionloadWXmodelFailed: {
    id: 'action.loadWXmodelFailed',
    defaultMessage: '加载微信模块失败...请刷新重试',
  },
  actionyouCancelPay: {
    id: 'action.youCancelPay',
    defaultMessage: '您已经取消支付',
  },
  actionpayUnsuccess: {
    id: 'action.payUnsuccess',
    defaultMessage: '支付失败',
  },
  actionPaid: {
    id: 'action.Paid',
    defaultMessage: '该订单已经结账',
  },
  actionbalancePaidFailed: {
    id: 'action.balancePaidFailed',
    defaultMessage: '余额支付失败, 即将刷新页面...',
  },
  actiongetRandomShareFailed: {
    id: 'action.getRandomShareFailed',
    defaultMessage: '获取随机分享减免信息失败',
  },
  actiongetRandomDiscountFailed: {
    id: 'action.getRandomDiscountFailed',
    defaultMessage: '获取随机减免金额失败，请重试',
  },
  actionshareFailed: {
    id: 'action.shareFailed',
    defaultMessage: '分享失败，请重试',
  },
  actiongetNewretailFailed: {
    id: 'action.getNewretailFailed',
    defaultMessage: '获取新零售接口失败',
  },
  actioncannotFindStoreInfo: {
    id: 'action.cannotFindStoreInfo',
    defaultMessage: '查询不到该手机号的储值信息，无法支付',
  },
  actionorderIsPaid: {
    id: 'action.orderIsPaid',
    defaultMessage: '订单已经支付',
  },
  actionVipBalanceInsufficient: {
    id: 'action.VipBalanceInsufficient',
    defaultMessage: '您的账户会员余额不足，请联系服务员充值',
  },
  actiongetShopInfoFailed: {
    id: 'action.getShopInfoFailed',
    defaultMessage: '获取商户信息失败...',
  },
  actionstopBooking: {
    id: 'action.stopBooking',
    defaultMessage: '暂停预订中...',
  },
  actiongetShopTableInfoFailed: {
    id: 'action.getShopTableInfoFailed',
    defaultMessage: '获取商户桌台信息失败...',
  },
  actionselectBookTime: {
    id: 'action.selectBookTime',
    defaultMessage: '请先选择预订时间...',
  },
  actionFixBookInfo: {
    id: 'action.FixBookInfo',
    defaultMessage: '请先完善预订信息...',
  },
  actionsubmitBookInfoFailed: {
    id: 'action.submitBookInfoFailed',
    defaultMessage: '提交预订信息失败...',
  },
  actiongetprePaidOrderFailed: {
    id: 'action.getprePaidOrderFailed',
    defaultMessage: '获取预支付订单号失败',
  },
  actiongetUserInfoFailed: {
    id: 'action.getUserInfoFailed',
    defaultMessage: '获取用户信息失败',
  },
  actioninterfaceRequestFailed: {
    id: 'action.interfaceRequestFailed',
    defaultMessage: '接口请求失败',
  },
  actionpassingVerify: {
    id: 'action.passingVerify',
    defaultMessage: '验证通过',
  },
  actionRegistering: {
    id: 'action.Registering',
    defaultMessage: '注册中，请稍后...',
  },
  actionuserRegisterFailed: {
    id: 'action.userRegisterFailed',
    defaultMessage: '用户注册失败',
  },
  actionupdateVipSuccessWithoutBind: {
    id: 'action.updateVipSuccessWithoutBind',
    defaultMessage:
      '升级会员成功，但无法绑定该卡，请检查您输入的卡号和密码。如遇问题，请联系海底捞顾客关怀中心 4008107107',
  },
  actionupdateVipSuccess: {
    id: 'action.updateVipSuccess',
    defaultMessage: '升级会员成功',
  },
  actioncannotFindWaiterId: {
    id: 'action.cannotFindWaiterId',
    defaultMessage: '找不到服务员ID',
  },
  actioninternetAnomaly: {
    id: 'action.internetAnomaly',
    defaultMessage: '网络异常, 请检查...',
  },
  actionnomoreShopInfo: {
    id: 'action.nomoreShopInfo',
    defaultMessage: '没有更多门店',
  },
  actiongetExpressInfoFailed: {
    id: 'action.getExpressInfoFailed',
    defaultMessage: '获取订单快递信息失败',
  },
  actionpayFailed: {
    id: 'action.payFailed',
    defaultMessage: '支付失败，请稍后重试',
  },
  actionpaySuccess2: {
    id: 'action.paySuccess2',
    defaultMessage: '支付成功',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/action/part4/index.js